import {
    USER_SUBMIT_FRUI_QPPZ_BEGIN,
    USER_SUBMIT_FRUI_QPPZ_SUCCESS,
    USER_SUBMIT_FRUI_QPPZ_FAILURE,
    USER_SUBMIT_FRUI_QPPZ_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFrui_qppz(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_SUBMIT_FRUI_QPPZ_BEGIN,
      });
  
      let apiurl = '/api/basic/gc';
  

    const promise = new Promise((resolve, reject) => {
        request({
          method:params.id != undefined ? 'PUT' : 'POST',
          url:apiurl,
          data: params,
        }).then( data => {
            dispatch({
                type: USER_SUBMIT_FRUI_QPPZ_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: USER_SUBMIT_FRUI_QPPZ_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFrui_qppzError() {
    return {
      type: USER_SUBMIT_FRUI_QPPZ_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_SUBMIT_FRUI_QPPZ_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFrui_qppzPending: true,
          submitFrui_qppzError: null,
        };
  
      case USER_SUBMIT_FRUI_QPPZ_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFrui_qppzPending: false,
          submitFrui_qppzError: null,
        };
  
      case USER_SUBMIT_FRUI_QPPZ_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFrui_qppzPending: false,
          submitFrui_qppzError: action.data.error,
        };
  
      case USER_SUBMIT_FRUI_QPPZ_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFrui_qppzError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/user/redux/submitFrui_qppz.js